






















































import { defineComponent, ref, watch, toRef, computed } from "@vue/composition-api";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { PurchaseSubjectTypeEnum } from "@scrile/api-provider/dist/api/PurchaseTypeProvider";
import { RecurringBillingScheduleSubjectTypeEnum } from "@scrile/api-provider/dist/api/RecurringBillingScheduleProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BoletoType from "./components/BoletoType.vue";
import CreditCardType from "./components/CreditCardType.vue";
import PixType from "./components/PixType.vue";

export default defineComponent({
  name: "Iugu",
  components: { PixType, BoletoType, CreditCardType, BaseConfirm, BaseButton },
  props: {
    show: { type: Boolean, required: true },
    processing: { type: Boolean, required: true },
    paymentSystem: { type: Object as () => PaymentSystemPublic, required: true },
    price: { type: String },
    pricePackageId: { type: String, required: true },
    purchaseSubject: { type: Object as () => Subject<PurchaseSubjectTypeEnum> },
    subscriptionSubject: { type: Object as () => Subject<RecurringBillingScheduleSubjectTypeEnum> },
  },
  setup(props) {
    const chosenType = ref<"creditCard" | "pix" | "boleto" | null>(null);
    watch(toRef(props, "show"), show => {
      if (!show) {
        chosenType.value = null;
      }
    });
    const showChoseType = computed(() => props.show && !chosenType.value);
    const onBack = () => {
      chosenType.value = null;
    };
    return {
      chosenType,
      showChoseType,
      onBack,
    };
  },
});
